// Shopify's standard formatMoney algorithm (same logic component-product-form.js
// and component-shipping-notice.js each already carry their own copy of), so a
// price built here matches shop.money_format exactly - including any HTML the
// format string contains (e.g. an inline currency symbol) - instead of the
// hardcoded "Dhs. " prefix this replaced, which never reflected the shop's
// actual currency formatting setting.
function _formatMoneyForColourSwap(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number === null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }
  return format.replace(placeholderRegex, value);
}
function changeProductNew(identifier) {
  var formSelector = $(identifier).data("handle") + "__form"
  var form = document.getElementById(formSelector)
  var old = $(identifier).data('parentproduct');
  var clicked = $(identifier).data('handle');
  var oldImg = "[data-id='" + old + "__img']";
  var oldImg2 = "[data-id='" + old + "_second__img']";
  var loader = "#" + old + "__load";
  var isTraditionalPage = document.body.classList.contains('template-collection-traditional');

  var swatchGroup = identifier.closest('colour-swatches');
  if (swatchGroup) {
    swatchGroup.querySelectorAll('.coloursquare').forEach(function(swatch){
      swatch.classList.remove('coloursquare--active');
    });
    identifier.classList.add('coloursquare--active');
  }

    $(loader).show();
    $(oldImg).hide();
     $(oldImg2).hide();
  var url = '/products/' + clicked + ".js";

  var jsonData = jQuery.getJSON(url, function(newproduct){
    var oldLink = "[data-id='" + old + "__link']";
    var oldImg = "[data-id='" + old + "__img']";
    var oldImg2 = "[data-id='" + old + "_second__img']";
    var oldTitle = "[data-id='" + old + "__title']";
    var oldCollectionName = "[data-id='" + old + "__collection-name']";
    var oldPrice = "[data-id='" + old + "__price']";
    var newLink = "/products/" + newproduct.handle;
    var oldForm = "[data-id='" + old + "__form']";
    

    var price = _formatMoneyForColourSwap(newproduct.price, KROWN.settings.shop_money_format);
    if (isTraditionalPage) {
      $(oldImg).attr('srcset', newproduct.images[1] || newproduct.featured_image);
      $(oldImg2).attr('srcset', newproduct.featured_image);
    } else {
      $(oldImg).attr('srcset', newproduct.featured_image);
      $(oldImg2).attr('srcset', newproduct.images[1] || newproduct.featured_image);
    }

    var revealSwappedImage = function(){
      $(loader).hide();
      $(oldImg).show();
      $(oldImg2).show();
    };
    var imgEl = document.querySelector(oldImg);
    if (imgEl && !imgEl.complete) {
      imgEl.addEventListener('load', revealSwappedImage, { once: true });
      imgEl.addEventListener('error', revealSwappedImage, { once: true });
    } else {
      revealSwappedImage();
    }
    // The collection-name eyebrow lives in its own row (data-id="..__collection-name"),
    // separate from the title span, so it can span/center across the whole
    // card instead of being constrained to the title/price column next to
    // the quick-add button. Keep this in sync with product-item.liquid.
    var collectionNameContainer = document.querySelector(oldCollectionName);
    if (collectionNameContainer) {
      collectionNameContainer.innerHTML = '';
      var newCollectionName = identifier.getAttribute('data-collection-name');
      if (newCollectionName) {
        var collectionSpan = document.createElement('span');
        collectionSpan.className = 'product-item__collection-name';
        collectionSpan.style.cssText = "font-weight: 500; text-decoration: underline; text-underline-offset: 4px; text-decoration-thickness: from-font; text-transform: uppercase;";
        collectionSpan.textContent = newCollectionName + ' Collection';
        collectionNameContainer.appendChild(collectionSpan);
      }
    }
    var titleContainer = document.querySelector(oldTitle);
    if (titleContainer) {
      titleContainer.innerHTML = '';
      var titleSpan = document.createElement('span');
      // Keep in sync with the title span in product-item.liquid: same
      // classes (product-item__title-text is what the collection-grid CSS
      // targets for the 12px size + 2-line clamp) and inline style.
      titleSpan.className = 'underline-animation product-item__title-text';
      titleSpan.style.fontWeight = '100';
      titleSpan.textContent = newproduct.title;
      titleContainer.appendChild(titleSpan);
    }
    $(oldLink).attr("href",newLink);
    // .html(), not .text(): price may now contain markup (e.g. an inline
    // currency-symbol SVG from shop.money_format), which .text() would
    // escape into literal visible tags instead of rendering.
    $(oldPrice).html(price);
    $(oldForm).attr("data-href",newLink);
    $(oldForm).load();
    console.log("reloaded");


  }).fail(function(){
    $(loader).hide();
    $(oldImg).show();
    $(oldImg2).show();
  });

}
  
